
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardOverview from '@/components/dashboard/DashboardOverview';
import Blogs from '@/pages/Blogs';
import BlogPost from '@/pages/BlogPost';
import EditBlogPost from '@/pages/EditBlogPost';
import NewBlogPost from '@/pages/NewBlogPost';
import Itineraries from '@/pages/Itineraries';
import ItineraryDetails from '@/pages/ItineraryDetails';
import EditItinerary from '@/pages/EditItinerary';
import NewItinerary from '@/pages/NewItinerary';
import Products from '@/pages/Products';
import UnifiedAnalytics from '@/pages/UnifiedAnalytics';
import Settings from '@/pages/Settings';
import Tags from '@/pages/Tags';
import Users from '@/pages/Users';
import NotFound from '@/pages/NotFound';
import Login from '@/pages/Login';
import PremiumItineraries from '@/pages/PremiumItineraries';
import PremiumItineraryDetails from '@/pages/PremiumItineraryDetails';
import NewPremiumItinerary from '@/pages/NewPremiumItinerary';
import EditPremiumItinerary from '@/pages/EditPremiumItinerary';
import StripeDiagnostics from '@/pages/StripeDiagnostics';
import ItineraryRequests from '@/pages/ItineraryRequests';
import AuthGuard from '@/components/auth/AuthGuard';
import RSSFeedTest from '@/pages/RSSFeedTest';
import ImageGallery from '@/components/image/ImageGallery';
import HeroImagesManagement from '@/pages/HeroImagesManagement';
import ShortContent from '@/pages/ShortContent';
import AffiliatePartners from '@/pages/AffiliatePartners';

const Dashboard = () => {
  return (
    <Routes>
      <Route index element={<DashboardOverview />} />
      <Route path="login" element={<Login />} />
      
      {/* Editor/Admin access routes */}
      <Route path="blogs" element={
        <AuthGuard requireEditor>
          <Blogs />
        </AuthGuard>
      } />
      <Route path="blogs/:id" element={
        <AuthGuard requireEditor>
          <BlogPost />
        </AuthGuard>
      } />
      <Route path="blogs/new" element={
        <AuthGuard requireEditor>
          <NewBlogPost />
        </AuthGuard>
      } />
      <Route path="blogs/:id/edit" element={
        <AuthGuard requireEditor>
          <EditBlogPost />
        </AuthGuard>
      } />
      <Route path="itineraries" element={
        <AuthGuard requireEditor>
          <Itineraries />
        </AuthGuard>
      } />
      <Route path="itineraries/new" element={
        <AuthGuard requireEditor>
          <NewItinerary />
        </AuthGuard>
      } />
      <Route path="itineraries/:id" element={
        <AuthGuard requireEditor>
          <ItineraryDetails />
        </AuthGuard>
      } />
      <Route path="itineraries/:id/edit" element={
        <AuthGuard requireEditor>
          <EditItinerary />
        </AuthGuard>
      } />
      <Route path="premium-itineraries" element={
        <AuthGuard requireEditor>
          <PremiumItineraries />
        </AuthGuard>
      } />
      <Route path="premium-itineraries/new" element={
        <AuthGuard requireEditor>
          <NewPremiumItinerary />
        </AuthGuard>
      } />
      <Route path="premium-itineraries/:id" element={
        <AuthGuard requireEditor>
          <PremiumItineraryDetails />
        </AuthGuard>
      } />
      <Route path="premium-itineraries/:id/edit" element={
        <AuthGuard requireEditor>
          <EditPremiumItinerary />
        </AuthGuard>
      } />
      <Route path="itinerary-requests" element={
        <AuthGuard requireEditor>
          <ItineraryRequests />
        </AuthGuard>
      } />
      <Route path="products" element={
        <AuthGuard requireEditor>
          <Products />
        </AuthGuard>
      } />
      <Route path="analytics" element={
        <AuthGuard requireEditor>
          <UnifiedAnalytics />
        </AuthGuard>
      } />
      <Route path="tags" element={
        <AuthGuard requireEditor>
          <Tags />
        </AuthGuard>
      } />
      <Route path="images" element={
        <AuthGuard requireEditor>
          <ImageGallery />
        </AuthGuard>
      } />
      <Route path="short-content" element={
        <AuthGuard requireEditor>
          <ShortContent />
        </AuthGuard>
      } />
      <Route path="affiliate-partners" element={
        <AuthGuard requireEditor>
          <AffiliatePartners />
        </AuthGuard>
      } />
      
      {/* Admin-only routes */}
      <Route path="users" element={
        <AuthGuard requireAdmin>
          <Users />
        </AuthGuard>
      } />
      <Route path="hero-images" element={
        <AuthGuard requireAdmin>
          <HeroImagesManagement />
        </AuthGuard>
      } />
      <Route path="stripe-diagnostics" element={
        <AuthGuard requireAdmin>
          <StripeDiagnostics />
        </AuthGuard>
      } />
      <Route path="rss-feed-test" element={
        <AuthGuard requireAdmin>
          <RSSFeedTest />
        </AuthGuard>
      } />
      
      {/* Regular user routes */}
      <Route path="settings" element={
        <AuthGuard>
          <Settings />
        </AuthGuard>
      } />
      
      {/* Catch all route for the dashboard section */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Dashboard;
